import React from 'react';
import SEO from '../components/SEO';

const Terms: React.FC = () => {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Conditions d\'Utilisation',
    description: 'Conditions d\'utilisation de BetSprinto',
  };

  return (
    <>
      <SEO
        title="Conditions d'Utilisation - BetSprinto"
        description="Consultez les conditions d'utilisation du site BetSprinto."
        jsonLd={jsonLd}
      />

      <div className="min-h-screen pt-28 py-12">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Conditions d'<span className="text-gradient">Utilisation</span>
          </h1>
          <p className="text-gray-400 mb-8">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>

          <div className="glass rounded-2xl p-8 md:p-12 space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">1. Acceptation des Conditions</h2>
              <p className="text-gray-300 leading-relaxed">
                En accédant et en utilisant BetSprinto, vous acceptez d'être lié par ces
                conditions d'utilisation. Si vous n'acceptez pas ces conditions, veuillez ne pas
                utiliser notre site.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">2. Utilisation du Site</h2>
              <p className="text-gray-300 leading-relaxed mb-4">Vous vous engagez à :</p>
              <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
                <li>Utiliser le site uniquement à des fins légales</li>
                <li>Ne pas tenter d'accéder à des zones non autorisées</li>
                <li>Ne pas perturber le fonctionnement du site</li>
                <li>Respecter les droits de propriété intellectuelle</li>
                <li>Avoir au moins 18 ans pour consulter les contenus de paris</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">3. Contenu du Site</h2>
              <p className="text-gray-300 leading-relaxed">
                Le contenu de BetSprinto est fourni à titre informatif uniquement. Nous nous
                efforçons de maintenir l'exactitude des informations, mais nous ne garantissons
                pas qu'elles soient complètes, à jour ou exemptes d'erreurs. Les informations sur
                les bonus et offres peuvent changer sans préavis.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">4. Liens Externes</h2>
              <p className="text-gray-300 leading-relaxed">
                Notre site contient des liens vers des sites tiers. Nous ne sommes pas responsables
                du contenu, des politiques de confidentialité ou des pratiques de ces sites externes.
                Nous vous encourageons à lire les conditions d'utilisation de chaque site que vous
                visitez.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">5. Propriété Intellectuelle</h2>
              <p className="text-gray-300 leading-relaxed">
                Tout le contenu de BetSprinto, incluant mais sans s'y limiter : textes, graphiques,
                logos, images, est la propriété de BetSprinto ou de ses partenaires et est protégé
                par les lois sur la propriété intellectuelle. Vous ne pouvez pas reproduire,
                distribuer ou utiliser ce contenu sans autorisation écrite.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">6. Limitation de Responsabilité</h2>
              <p className="text-gray-300 leading-relaxed">
                BetSprinto ne peut être tenu responsable des dommages directs ou indirects résultant
                de l'utilisation ou de l'impossibilité d'utiliser notre site. Nous ne garantissons
                pas que le site sera toujours disponible, sécurisé ou exempt d'erreurs.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">7. Jeu Responsable</h2>
              <p className="text-gray-300 leading-relaxed">
                BetSprinto promeut le jeu responsable. Les paris sportifs peuvent créer une
                dépendance. Si vous pensez avoir un problème de jeu, contactez des organisations
                d'aide. Nous ne sommes pas responsables des pertes financières liées aux paris.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">8. Modifications</h2>
              <p className="text-gray-300 leading-relaxed">
                Nous nous réservons le droit de modifier ces conditions d'utilisation à tout
                moment. Les modifications entreront en vigueur dès leur publication sur le site. Il
                est de votre responsabilité de consulter régulièrement ces conditions.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">9. Contact</h2>
              <p className="text-gray-300 leading-relaxed">
                Pour toute question concernant ces conditions d'utilisation, contactez-nous à :{' '}
                <a href="mailto:contact@betsprinto.com" className="text-accent-primary hover:underline">
                  contact@betsprinto.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default Terms;

